import { api } from "./api";
import { CoOwnerResult, CoownerValidationResult, DogRegistrationIndividualRequest, DogRegistrationIndividualFeeData } from "@/types/portal/Registration";
import { withoutActorIdentity } from "./portal/actorIdentity";

export const searchCoOwner = async (membershipID: string): Promise<CoownerValidationResult[]> => {
    const normalizedMembershipID = membershipID.trim();
    if (!normalizedMembershipID) return [];

    const { data } = await api.get<CoownerValidationResult[]>(`/DogRegistration/individual/coowner/${normalizedMembershipID}`)
    return data;
}

export const getPuppyRegistrationInfoById = async (puppyId: number): Promise<any> => {
    const { data } = await api.get(`DogRegistration/individual/puppies/${puppyId}`);

    return data;
};


export const validateDogName = async (puppyId: number, name: string): Promise<any> => {
    const { data } = await api.get(`DogRegistration/individual/${puppyId}/validate/${name}`);

    return data;
};

export const registerDogIndividual = async(registerDTO: DogRegistrationIndividualRequest): Promise<any> => {
    const { data } = await api.post<object>(`/DogRegistration/individual/register`, withoutActorIdentity(registerDTO));
    return data;
}
export const calculatePuppyRegistrafionFee = async (requestData: DogRegistrationIndividualFeeData): Promise<any> => {
    const { data } = await api.post<object>(`DogRegistration/individual/registration/fee`, withoutActorIdentity(requestData));

    return data;
};

export default {
    searchCoOwner,
    getPuppyRegistrationInfoById,
    validateDogName,
    registerDogIndividual,
    calculatePuppyRegistrafionFee,
}
